import React from "react";
import Header_Footer from "../Layout/Header_Footer";
import "./styles/PNF.css";

const PageNF = () => {
  return (
    <Header_Footer title={"404"}>
      <div className="pnf-row">
        <div className="pnf-col">
          <h1>404</h1>
          <p>Page Not Found</p>
        </div>
      </div>
    </Header_Footer>
  );
};

export default PageNF;
